import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLayout } from '../../context/LayoutContext';

const PROMOS = [
  { icon: 'ri-shopping-bag-line', text: 'Consulta nuestro catálogo de hardware gaming y componentes PC', cta: 'Ver Catálogo', href: '/catalogo' },
  { icon: 'ri-tools-line', text: 'Cotiza tu ensamblaje personalizado por WhatsApp', cta: 'Cotizar', href: 'https://wa.me/18492081166', external: true },
  { icon: 'ri-customer-service-2-line', text: 'Soporte técnico presencial en Santo Domingo Este', cta: 'Agendar', href: '/agendar' },
  { icon: 'ri-map-pin-line', text: 'Visítanos en nuestra tienda física — Ens. Ozama, SDE', cta: 'Ubicación', href: 'https://maps.app.goo.gl/fiVfv1yGkZk2UDSG6', external: true },
];

export default function PromoBar() {
  const { promoVisible, dismissPromo } = useLayout();
  const [idx, setIdx] = useState(0);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    if (!promoVisible) return;
    const interval = setInterval(() => {
      setAnimating(true);
      setTimeout(() => {
        setIdx((i) => (i + 1) % PROMOS.length);
        setAnimating(false);
      }, 250);
    }, 5000);
    return () => clearInterval(interval);
  }, [promoVisible]);

  if (!promoVisible) return null;

  const promo = PROMOS[idx];
  const isExternal = promo.external || promo.href.startsWith('http');

  const linkProps = {
    className: "flex-shrink-0 bg-white/20 hover:bg-white/30 text-white text-[10px] font-black uppercase tracking-wider px-2.5 py-1 rounded-full transition-all cursor-pointer whitespace-nowrap",
  };

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] h-10 flex items-center justify-center px-4 gap-3"
      style={{ background: 'linear-gradient(90deg, #7f1d1d 0%, #dc2626 40%, #7f1d1d 100%)' }}
    >
      {/* Promo message */}
      <div
        className="flex items-center gap-2 flex-1 justify-center min-w-0"
        style={{
          opacity: animating ? 0 : 1,
          transform: animating ? 'translateY(4px)' : 'translateY(0)',
          transition: 'opacity 0.25s ease, transform 0.25s ease',
        }}
      >
        <i className={`${promo.icon} text-white/90 text-sm flex-shrink-0`} />
        <p className="text-white text-[11px] font-semibold truncate hidden sm:block">
          {promo.text}
        </p>
        <p className="text-white text-[11px] font-semibold truncate sm:hidden">
          {promo.text.substring(0, 50)}...
        </p>
        {isExternal ? (
          <a
            href={promo.href}
            target="_blank"
            rel="nofollow noreferrer"
            {...linkProps}
          >
            {promo.cta}
          </a>
        ) : (
          <Link to={promo.href} {...linkProps}>
            {promo.cta}
          </Link>
        )}
      </div>

      {/* Dots */}
      <div className="hidden md:flex items-center gap-1 flex-shrink-0">
        {PROMOS.map((_, i) => (
          <button
            key={i}
            onClick={() => setIdx(i)}
            className={`rounded-full transition-all cursor-pointer ${i === idx ? 'w-3 h-1.5 bg-[#ffffff]' : 'w-1.5 h-1.5 bg-white/40 hover:bg-white/60'}`}
          />
        ))}
      </div>

      {/* Close */}
      <button
        onClick={dismissPromo}
        className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full hover:bg-white/20 transition-colors cursor-pointer ml-1"
        aria-label="Cerrar"
      >
        <i className="ri-close-line text-white text-sm" />
      </button>
    </div>
  );
}